import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));

const WorkforceLayout = lazy(() => import('@/pages/workforce/layout'));
const WorkforcePage = lazy(() => import('@/pages/workforce'));

const WorkforceOldLayout = lazy(() => import('@/pages/workforce-old/layout'));
const WorkforceOldPage = lazy(() => import('@/pages/workforce-old'));

/**
 * Workforce (xyflow tree, new design)
 */
export const workforceRoutes: RouteConfig = {
  path: '/workforce',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: WorkforceLayout,
      element: WorkforcePage,
    },
  ],
};

/**
 * Workforce legacy (drag-board Card + UserHierarchy) — kept until the
 * xyflow page is stable in production. Same permissions as the new one.
 */
export const workforceOldRoutes: RouteConfig = {
  path: '/workforce-old',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: WorkforceOldLayout,
      element: WorkforceOldPage,
    },
  ],
};
